<template>
    <div class="map-mobile-multi-location-selector">
        <b-btn variant="light" block size="lg" class="selector-trigger" @click="open">
            <div class="selector-content">
                <i class="fak fa-regular-location-dot-location-pin" />
                <div class="selector-name">{{ mapItems.length }} {{ selectedMapItem.getFullName() }}</div>
            </div>
            <i :class="[fontAwesomePrefix, 'fa-chevron-right']" />
        </b-btn>

        <e-mobile-modal v-model="visible" position="center" :title="$t('map.trajectory.locations')">
            <b-list-group flush class="map-mobile-list-group">
                <b-list-group-item v-for="mapItem in mapItems" :key="mapItem.id"
                    class="interactive active-scale"
                    :class="{ 'active-item': mapItem.id === selectedMapItemId }"
                    @click="selectMapItem(mapItem)">
                    <div class="list-group-item-icon">
                        <i :class="mapItem.getGlyph(fontAwesomePrefix)" />
                    </div>
                    <div class="list-group-item-content">
                        <div>{{ mapItem.getFullName() }}</div>
                        <div class="selector-details">
                            <div v-if="mapItem?.address" class="selector-address">{{ mapItem.address }}</div>
                            <div class="text-muted">{{ getLevel(mapItem) }}</div>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </e-mobile-modal>
    </div>
</template>

<script>
import EMobileModal from "@/components/e-mobile-modal.vue";
import MapMixin from "@/helpers/maps/map-mixin.js";

export default {
    name: `map-items-selector`,
    components: { EMobileModal },
    mixins: [MapMixin],
    props: {
        mapItems: { type: Array, default: () => [] },
        selectedMapItemId: { type: String, default: null }
    },
    data() {
        return {
            visible: false
        };
    },
    computed: {
        selectedMapItem() {
            return this.mapItems.find((mapItem) => mapItem.id === this.selectedMapItemId) || this.mapItems[0];
        }
    },
    methods: {
        open() {
            this.visible = true;
        },
        selectMapItem(mapItem) {
            this.$emit(`selected`, mapItem);
            this.visible = false;
        },
        getLevel(mapItem) {
            const floor = mapItem.map.getFloorById(mapItem.floorId);
            return this.tr(floor?.name) || '-';
        },
    }
};
</script>

<style lang="scss" scoped>
@import "./map-mobile-list-group.scss";

.map-mobile-multi-location-selector {
    margin-bottom: 12px;

    .selector-trigger {
        display: flex;
        align-items: center;
        border-radius: 8px;
        color: black;

        i {
            margin-left: auto;
            color: var(--color-dark);
        }
    }

    .selector-content {
        display: flex;
        align-items: center;
        gap: 6px;

        i {
            color: var(--color-dark);
            margin-right: 8px;
            font-size: 12pt;
        }
    }

    .selector-name {
        font-size: 11pt;
        font-weight: 600;
        color: var(--color-dark);
    }

    .selector-details {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .selector-address {
        background-color: var(--color-light);
        border-radius: 4px;
        padding: 4px;
        display: grid;
        place-items: center;
        width: 24px;
        height: 24px;
        line-height: 1;
    }

    .selector-level {
        font-size: 10pt;
        color: var(--color-muted);
    }

    .active-item {
        background: color-mix(in srgb, var(--color-accent) 8%, white);
    }
}
</style>
